'use client';

import classNames from 'classnames';
import { Container } from 'components/gruenland/atoms/container/Container';
import MarkdownRenderer, { Props as MarkdownProps } from 'components/gruenland/organisms/markdown/MarkdownRenderer';
import { TasticProps } from '../../types';

interface Props extends MarkdownProps {
  textAlign: 'center' | 'left' | 'right' | 'justify';
}

const YggdrasilMarkdownTastic = ({ data }: TasticProps<Props>) => {
  return (
    <Container>
      <div
        className={classNames('prose max-w-full', {
          'text-center': data.textAlign === 'center',
          'text-left': data.textAlign === 'left',
          'text-right': data.textAlign === 'right',
          'text-justify': data.textAlign === 'justify',
        })}
      >
        <MarkdownRenderer markdown={data.markdown} />
      </div>
    </Container>
  );
};

export default YggdrasilMarkdownTastic;
